import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A3C90E",
      d: "M12.495 0c.432 0 .825.244 1.013.633l3.215 6.623 7.182 1.06c.421.06.773.356.904.764a1.13 1.13 0 0 1-.276 1.148l-5.208 5.166 1.228 7.294c.07.421-.103.848-.45 1.101a1.12 1.12 0 0 1-1.186.08l-6.422-3.431-6.417 3.426c-.38.202-.839.174-1.186-.08a1.14 1.14 0 0 1-.455-1.101l1.229-7.294-5.208-5.16a1.12 1.12 0 0 1-.277-1.15c.131-.402.483-.698.905-.763l7.181-1.06L11.483.633c.192-.39.581-.633 1.012-.633m0 3.703-2.46 5.072a1.14 1.14 0 0 1-.85.623l-5.544.816 4.026 3.99c.258.257.38.623.319.983l-.952 5.611 4.932-2.634a1.12 1.12 0 0 1 1.059 0l4.931 2.634-.947-5.606c-.06-.36.057-.726.32-.984l4.026-3.99-5.546-.82a1.13 1.13 0 0 1-.848-.623z"
    }, null, -1)
  ]))]))
}
export default { render: render }